module.exports = __webpack_public_path__ + "media/images/countdown__background-9bd680944cd71778e147ffa0110e7044.jpg";